module.exports = __webpack_public_path__ + "static/New_Hero_Medium-840d181481cd3cf80b478f01e3057fbc.otf";